<template>
  <div class="page-box">
    <!-- 头部标题 +++++++++++++++++++++++++++++++++++++++++ -->
    <div class="dtl-head">
      <div class="pageTit c-breadcrumb">
        <el-breadcrumb separator=">" class="theme-default">
          <el-breadcrumb-item :to="{ path: '/financingExamineList' }"> {{ $t('financingExamineDetail.nav1') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('financingFundDetail.tittle') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!--流水号-->
      <p class="top-tit" style="text-align:right;padding-right:90px;width:unset"><span>{{ $t('loan.financingNum') }}：</span>
        <span>{{ flowNumber }}</span>
      </p>
      <!-- 分割图片 -->
      <img class="c-divider" src="../../assets/images/common/documentSeparation.png" alt="">
    </div>

    <div class="bonusDetail" style="margin-top: -5px;">

      <div class="" style="min-height: 260px;margin-bottom: 20px;">
        <el-tabs type="border-card" class="theme-default" style="background:none; ">
          <!--cic合同-->
          <el-tab-pane v-if="Array.isArray(cicTradeContractSnapshotList)&& cicTradeContractSnapshotList.length>0&&zmaFinancingManagement.applicationStatus!=15&&zmaFinancingManagement.applicationStatus!=16" :label="$t('loan.cicContract')" style="padding: 0">
            <!--cic合同-->
            <cicContract v-if="Array.isArray(cicTradeContractSnapshotList) &&cicTradeContractSnapshotList.length" :contract="cicTradeContractSnapshotList"/>

            <!--定金资料-->
            <div v-if="cicDepositInfoSnapshotList&& cicDepositInfoSnapshotList.length > 0" class="box-item top mb_20">
              <z-collapse :title="$t('loan.depositInfo')" :is-toggle="true" :is-hide="false">
                <div v-if="cicDepositInfoSnapshotList && cicDepositInfoSnapshotList.length > 0" class="card-box">
                  <div v-for="(item,index) in cicDepositInfoSnapshotList" :key="index" class="single-card">
                    <z-card :title="applyStatus[item.depositType]">
                      <ul class="card-list">
                        <li><span class="tit">{{ $t('loan.depositAmount') }}</span><div class="msg">{{ item.depositCurrency }} {{ item.deposit | formatNum }}</div></li> <!--定金金额-->
                        <li><span class="tit">{{ $t('loan.invoiceNo') }}</span><div class="msg">{{ item.invoiceNumber }}</div></li> <!--发票号-->
                        <li><span class="tit">{{ $t('loan.depositIDate') }}</span><div class="msg">{{ item.paymentDate | dateConvert }}</div></li> <!--定金付款日-->
                        <li><span class="tit">{{ $t('loan.fileUpload') }}</span>
                          <div v-if="item.depositInfoFileList && item.depositInfoFileList.length>0" class="msg c-file-list">
                            <a v-for="(listItem, index) in item.depositInfoFileList" :key="index" :href="zmaDownloadFile(listItem.fileCode)" target="_blank"><i :class="getFileType(listItem.fileName)" class="file-icon"/>{{ listItem.fileName }}</a>
                          </div>
                        </li>
                        <!--文件上传-->
                      </ul>
                    </z-card>
                  </div>
                  <!--采购合同、销售合同、终端合同-->
                </div>
              </z-collapse>
            </div>

            <div v-if="addFileInfoList&& addFileInfoList.length > 0" class="box-item top mb_20">
              <z-collapse :title="$t('loan.addFile')" :is-toggle="true" :is-hide="false">
                <div class="c-list-bg no-pt">
                  <ul class="c-list">
                    <li class="w-100"><span class="tit">{{ $t('loan.addFile') }}：</span><div class="msg c-file-list">
                      <a v-for="(fileObj,fileIndex) in addFileInfoList" :key="fileIndex" :href="zmaDownloadFile(fileObj.fileCode)" target="_blank">
                        <i :class="getFileType(fileObj.fileName)" class="file-icon"/>{{ fileObj.fileName }}
                      </a>
                    </div></li>
                  </ul>
                </div>
                <p class="pb-10"/>
              </z-collapse>
            </div>

            <div v-if="tradeContractList && tradeContractList.length>0" class="box-item top mb_20">
              <!--  贸易合同审核记录-->
              <z-collapse :title="$t('loan.tradeContractRecord')" :is-toggle="true">
                <div v-if="zmaAuditLog" class="card-box">
                  <!-- 贸易合同审核记录-->
                  <zmaAuditLog :data="zmaAuditLog" :list-type="6"/>
                </div>
              </z-collapse>
            </div>

            <div v-if="frontMoneyList && frontMoneyList.length>0" class="box-item top mb_20">
              <!--                  定金审核记录-->
              <z-collapse :title="$t('loan.depositAuditRecord')" :is-toggle="true">
                <div v-if="zmaAuditLog" class="card-box">
                  <!-- 定金审核记录-->
                  <zmaAuditLog :data="zmaAuditLog" :list-type="5"/>
                </div>
              </z-collapse>
            </div>

          </el-tab-pane>

          <!--融资合同-->
          <el-tab-pane :label="$t('loan.financingContract')">
            <div class="box-item top mb_20">
              <!-- CIC费用-->
              <cicFee v-if="cicFinancingCostDraftSnapshot" :data="cicFinancingCostDraftSnapshot"/>
              <div class="nyTit"><i/>{{ $t('loan.financingInfo') }}</div>
              <!-- 融资信息 -->
              <financingInfo v-if="zmaFinancingInfo" ref="zmaFinancingInfo" :status="applicationStatus" :data="zmaFinancingInfo" @update="confirmUpdate"/>

            </div>
            <div v-if="lockMoneyList&&lockMoneyList.length>0" class="box-item top mb_20" style="padding-bottom: 10px">
              <fund-lock ref="fundLock" @confirm="confirmUpdate"/>
              <!--                  资金锁定-->

              <!--                  资金锁定审核记录-->
              <div class="nyTit"><i/>{{ $t('loan.fundLockAuditRecord') }}</div>
              <zmaAuditLog :data="zmaAuditLog" :list-type="2"/>
            </div>
          </el-tab-pane>
          <!--              申请基本信息-->
          <el-tab-pane :label="$t('loan.applyBasicInfo')" >
            <div v-if="cicFinancingApplyDraftSnapshot" class="box-item top mb_20" style="padding-bottom: 10px">
              <!--贸易信息-->
              <z-collapse :title="$t('loan.tradeInfo')" :is-toggle="true">
                <!--贸易信息-->
                <baseTradeInfo :data="cicFinancingApplyDraftSnapshot"/>
              </z-collapse>

              <!--                  融资基础信息-->
              <z-collapse :title="$t('loan.financingBasicInfo')" :is-toggle="true">
                <!--  融资基础信息-->
                <financingBaseInfo :data="cicFinancingApplyDraftSnapshot" />
              </z-collapse>
            </div>

            <base-info-finance ref="baseDataFinance"/>
            <!--  当前融资情况 + 最近10笔融资申请 + 最近10笔订单 -->

            <div class="box-item top mb_20" style="padding-bottom: 10px" >
              <!--评级-->
              <rankInfo v-if="zmaFinancingManagement" :data="zmaFinancingManagement" :cic-financing-apply-draft-snapshot="cicFinancingApplyDraftSnapshot" />
              <!--                  风控审核记录-->
              <z-collapse v-if="riskManageList&&riskManageList.length>0" :title="$t('loan.riskAuditRecord')" :is-toggle="true">
                <zmaAuditLog :data="zmaAuditLog" :list-type="1"/>
              </z-collapse>
            </div>

          </el-tab-pane>
        </el-tabs>
      </div>
      <div style="height: 110px;"/>
      <div v-if="isShowFooter&&(applicationStatus===17 || applicationStatus===24)" class="text-center whiteFixed">
        <!--            <div class="centerBtn btn-blue" @click="back" v-if="!isFrontMoney">-->
        <!--              &lt;!&ndash;返回&ndash;&gt;-->
        <!--              {{$t('btns.back')}}-->
        <!--            </div>-->
        <div class="centerBtn btn-blue" @click="isShow = true">
          <!--             打回-->
          {{ $t('btns.repulse') }}
        </div>
        <div class="centerBtn btn-blue" @click="isShowPass = true">
          <!--             提交-->
          {{ $t('btns.submit') }}
        </div>
      </div>
      <!-- 一审-->
      <div v-if="isShowFooter&&(applicationStatus===18 ||applicationStatus===25)" class="text-center whiteFixed">
        <!--            <div class="centerBtn btn-blue"  @click="back" v-if="!isFrontMoney">-->
        <!--              &lt;!&ndash;返回&ndash;&gt;-->
        <!--              {{$t('btns.back')}}-->
        <!--            </div>-->
        <div class="centerBtn btn-blue" @click="isShow = true">
          <!--              打回-->
          {{ $t('btns.repulse') }}
        </div>
        <div class="centerBtn btn-blue" @click="isShowPass=true">
          <!--              通过-->
          {{ $t('btns.pass') }}
        </div>
      </div>
      <!-- 二审-->
      <div v-if="isShowFooter&&(applicationStatus===19 ||applicationStatus===26)" class="text-center whiteFixed">
        <div class="centerBtn btn-blue" @click="isShow = true">
          <!--              打回-->
          {{ $t('btns.repulse') }}
        </div>
        <div v-if="applicationStatus===19" class="centerBtn btn-blue" @click="isShowClose=true">
          <!--              拒绝-->
          {{ $t('btns.refuse') }}
        </div>
        <div class="centerBtn btn-blue" @click="isShowPass=true">
          <!--              通过-->
          {{ $t('btns.pass') }}
        </div>
      </div>
    </div>

    <!--通过弹框 begin-->
    <VerifyPopup v-if="isShowPass" :title="$t('fancingFundDetail.surePass')" :placeholder="$t('financingFundDetail.verifyPopupPlaceholder')" maxlength="300" @cancel="hide" @confirm="submitAdopt"/>
    <!--通过弹框 end-->
    <!--打回弹框 begin-->
    <VerifyPopup v-if="isShow" :title="$t('fancingFundDetail.sureBack')" :placeholder="$t('financingFundDetail.verifyPopupPlaceholder')" maxlength="300" @cancel="hide" @confirm="submitRepulse"/>
    <!--打回弹框 end-->
    <!--拒绝弹框 begin-->
    <VerifyPopup v-if="isShowClose" :title="$t('fancingFundDetail.sureReject')" :placeholder="$t('financingFundDetail.verifyPopupPlaceholder')" maxlength="300" @cancel="isShowClose=false" @confirm="submitClose"/>
    <!--拒绝弹框 end-->
  </div>
</template>
<script>
import fundLock from '@/components/pageDtl/fundLock'
import VerifyPopup from '../../components/VerifyPopup'
import cicContract from '../../components/financingComponents/cicContract'
import tradeContractRecord from '../../components/financingComponents/tradeContractRecord'
import cicFee from '../../components/financingComponents/cicFee'
import financingInfo from '../../components/financingComponents/financingInfo'
import fundLockAuditRecord from '../../components/financingComponents/fundLockAuditRecord'
import baseTradeInfo from '../../components/financingComponents/baseTradeInfo'
import financingBaseInfo from '../../components/financingComponents/financingBaseInfo'
import zmaAuditLog from '../../components/financingComponents/zmaAuditLog'
import rankInfo from '../../components/financingComponents/rankInfo'
import ZCollapse from '@/components/ZCollapse'
import ZCard from '@/components/ZCard'
import baseInfoFinance from '@/components/pageDtl/baseInfoFinance'
import mixins from '@/helper/mixins.js'
import { mapState } from 'vuex'

export default {
  name: 'FinancingExamineDetail',
  mixins: [mixins],
  data() {
    return {
      ifIsSuper: '',
      menuType: '',
      applicationStatus: '',
      flowNumber: this.$route.query.in_id,
      moneyType: '',
      isFrontMoney: false,
      applyStatus: {
        '1': this.$t('loan.buyContract'),
        '2': this.$t('loan.saleContract'),
        '3': this.$t('loan.terminalContract')
      },
      isShowFooter: false,
      submited: false, // 防止重复提交
      isShow: false,
      isShowPass: false,
      isShowClose: false, // 拒绝弹框开关
      tqTipPopVisible: false, // 提取弹窗开关
      hasPermission: false,
      cicTradeContractSnapshotList: '',
      zmaAuditLog: '',
      riskManageList: [], // 风控审核记录
      lockMoneyList: [], // 资金锁定审核记录
      tradeContractList: [], // 贸易合同审核记录
      frontMoneyList: [], // 定金审核记录
      zmaFinancingInfo: '',
      cicFinancingApplyDraftSnapshot: '',
      zmaFinancingManagement: '',
      cicFinancingCostDraftSnapshot: '',
      cicDepositInfoSnapshotList: '',
      addFileInfoList: '',
      formObj: {
        flowNumber: this.$route.query.in_id,
        estimateStartDate: '',
        estimateEndDate: '',
        financingMoney: '',
        financingCurrency: '',
        interestRate: '',
        interest: '',
        interestCurrency: '',
        grantCurrency: '',
        repaymentCurrency: '',
        exchangeRate: '',
        lockedMoney: ''
      }, //
      contractParameter: {
        in_fl: this.$route.query.in_id,
        in_log: ''// 审核意见
      }, // /贸易合同提交 打回通过 拒绝入参
      frontMoneyParameter: {
        f_n: this.$route.query.in_id,
        a_o: ''
      },
      pathArr: {
        'contractAuditAdopt': '/zma/api/contractAudit/adopt', // 贸易合同审核-提交
        'contractAuditFirstAdopt': '/zma/api/contractAudit/firstAdopt', // 贸易合同一审-通过
        'contractAuditSecondAdopt': '/zma/api/contractAudit/secondAdopt', // 贸易合同二审-通过
        'contractAuditBack': '/zma/api/contractAudit/back', // 贸易合同审核-打回
        'contractAuditFirstBack': '/zma/api/contractAudit/firstBack', // 贸易合同一审-打回
        'contractAuditSecondBack': '/zma/api/contractAudit/secondBack', // 贸易合同二审-打回
        'contractAuditSecondRefuse': '/zma/api/contractAudit/secondRefuse', // 贸易合同-拒绝
        'depositSubmit': '/zma/api/deposit/depositSubmit', // 定金审核-提交
        'depositFirstInstanceAdopt': '/zma/api/deposit/depositFirstInstanceSubmit', // 定金一审-通过
        'depositSecondInstanceAdopt': '/zma/api/deposit/depositSecondInstanceSubmit', // 定金二审-通过
        'depositRepulse': '/zma/api/deposit/depositRepulse', // 定金审核-打回
        'depositFirstInstanceRepulse': '/zma/api/deposit/depositFirstInstanceRepulse', // 定金一审-打回
        'depositSecondInstanceRepulse': '/zma/api/deposit/depositSecondInstanceRepulse'// 定金二审-打回
        // 定金二审没有拒绝
      },

      fundData: [] // 资金锁定信息
    }
  },
  computed: {
    ...mapState(['userProfile']),
    loanName() {
      return this.userProfile.loanName // 登录用户名
    }
  },
  components: {
    fundLock,
    VerifyPopup,
    cicContract,
    tradeContractRecord,
    cicFee,
    financingInfo,
    fundLockAuditRecord,
    baseTradeInfo,
    financingBaseInfo,
    zmaAuditLog,
    ZCollapse,
    rankInfo,
    ZCard,
    baseInfoFinance
  },
  mounted() {
    this.$nextTick(function() {
      document.title = this.$t('financingExamineDetail.nav1')
      const isFrontMoney = this.$route.query.isFrontMoney
      if (isFrontMoney) {
        this.isFrontMoney = true
      }
      if (this.isFrontMoney) {
        // 定金详情接口调用
        this.getFrontMoneyDetail()
      } else {
        // 贸易合同详情接口调用
        this.getTradeDetail()
      }

      const menuType = Number(this.$route.query.menuType)
      if (menuType) {
        this.menuType = menuType
      }
      this.isSuper()
      const ifIsSuper = this.ifIsSuper
      if (ifIsSuper === 1) {
        this.isShowFooter = true
      } else {
        this.getBtnLimit(this.flowNumber).then(data => {
          console.log('type', data.type)
          if (data.type) {
            this.isShowFooter = true
          } else {
            this.isShowFooter = false
          }
        }) // 获取系统按钮权限
      }
      this.getdiscList()
    })
  },
  methods: {
    confirmUpdate() {
      // this.getTradeDetail();
      if (this.isFrontMoney) {
        // 定金详情接口调用
        this.getFrontMoneyDetail()
      } else {
        // 贸易合同详情接口调用
        this.getTradeDetail()
      }
    }, // 修改锁定金额成功回调

    back: function() {
      this.$router.go(-1)
    },
    // 判斷是否管理員
    isSuper() {
      this.ifIsSuper = parseInt(this.$utils.getStorage('userProfile').isSuper)
    },
    submitForm() {
      this.submitAdopt()
      // if (valid) {
      //   this.zmaAdopt()
      // } else {
      //   console.log('error submit!!');
      //   return false;
      // }
    },
    // 取字典表的value
    getdiscList() {
      this.axios.get('/static/sysDict/sysDictValue.json')
        .then(res => {
          // console.log('字典表',res);
          if (res.moneyType && res.moneyType.en) {
            this.moneyType = res.moneyType.en
          }
        })
        .catch(err => {
          this.$message.error(this.$t(`frontPage.${err.errorCode}`))
        })
    },
    /**
       * 贸易合同详情页面
       * @returns {Promise.<T>|Promise<never | T>}
       */
    getTradeDetail: function() {
      const params = {
        in_fl: this.flowNumber
      }
      var promise = this.axios.post('/zma/api/contractAudit/depositDetail', params)
        .then(response => {
          if (response.status) {
            // console.log('贸易合同详情页面', response);
            const { cicTradeContractSnapshotList, zmaAuditLog, cicDepositInfoSnapshotList, cicFinancingCostDraftSnapshot, zmaFinancingInfo, cicFinancingApplyDraftSnapshot, zmaFinancingManagement, addFileInfoList, zmaFinancingOrderVo } = response.data
            this.$refs.baseDataFinance.handleInit(zmaFinancingOrderVo)

            if (cicTradeContractSnapshotList && Array.isArray(cicTradeContractSnapshotList)) {
              this.cicTradeContractSnapshotList = cicTradeContractSnapshotList
            }
            if (cicDepositInfoSnapshotList && Array.isArray(cicDepositInfoSnapshotList)) {
              this.cicDepositInfoSnapshotList = cicDepositInfoSnapshotList
            }
            if (zmaAuditLog && Array.isArray(zmaAuditLog)) {
              this.zmaAuditLog = zmaAuditLog
              if (zmaAuditLog.length > 0) {
                this.riskManageList = this.zmaAuditLog.filter(item =>
                  item.processType === 1
                )
                this.lockMoneyList = this.zmaAuditLog.filter(item =>
                  item.processType === 2
                )
                this.frontMoneyList = this.zmaAuditLog.filter(item =>
                  item.processType === 5
                )
                this.tradeContractList = this.zmaAuditLog.filter(item =>
                  item.processType === 6
                )
              }
            }
            if (cicFinancingCostDraftSnapshot && this.$utils.isObjFn(cicFinancingCostDraftSnapshot)) {
              this.cicFinancingCostDraftSnapshot = cicFinancingCostDraftSnapshot
            }
            if (zmaFinancingInfo && this.$utils.isObjFn(zmaFinancingInfo)) {
              this.zmaFinancingInfo = zmaFinancingInfo
            }
            if (cicFinancingApplyDraftSnapshot && this.$utils.isObjFn(cicFinancingApplyDraftSnapshot)) {
              this.cicFinancingApplyDraftSnapshot = cicFinancingApplyDraftSnapshot
            }
            if (zmaFinancingManagement && this.$utils.isObjFn(zmaFinancingManagement)) {
              this.zmaFinancingManagement = zmaFinancingManagement
            }
            if (addFileInfoList && Array.isArray(addFileInfoList)) {
              this.addFileInfoList = addFileInfoList
            }
            this.applicationStatus = zmaFinancingManagement.applicationStatus

            this.setInitData(response.data)
          } else {
            this.linkToList(response.errorCode)
          }
        })

      return promise
    },

    /**
       * 定金详情页面
       * @returns {Promise.<T>|Promise<never | T>}
       */
    getFrontMoneyDetail: function() {
      const params = {
        f_l: this.flowNumber
      }
      var promise = this.axios.post('/zma/api/deposit/depositDetail', params)
        .then(response => {
          if (response.status) {
            // console.log('贸易合同详情页面', response);
            const { cicTradeContractSnapshotList, zmaAuditLog, cicFinancingCostDraftSnapshot, zmaFinancingInfo, cicFinancingApplyDraftSnapshot, zmaFinancingManagement, cicDepositInfoSnapshotList, addFileInfoList } = response.data
            if (cicTradeContractSnapshotList && Array.isArray(cicTradeContractSnapshotList)) {
              this.cicTradeContractSnapshotList = cicTradeContractSnapshotList
            }
            if (zmaAuditLog && Array.isArray(zmaAuditLog)) {
              this.zmaAuditLog = zmaAuditLog
              if (zmaAuditLog.length > 0) {
                this.riskManageList = this.zmaAuditLog.filter(item =>
                  item.processType === 1
                )
                this.lockMoneyList = this.zmaAuditLog.filter(item =>
                  item.processType === 2
                )
                this.frontMoneyList = this.zmaAuditLog.filter(item =>
                  item.processType === 5
                )
                this.tradeContractList = this.zmaAuditLog.filter(item =>
                  item.processType === 6
                )
              }
            }
            if (cicFinancingCostDraftSnapshot && this.$utils.isObjFn(cicFinancingCostDraftSnapshot)) {
              this.cicFinancingCostDraftSnapshot = cicFinancingCostDraftSnapshot
            }
            if (zmaFinancingInfo && this.$utils.isObjFn(zmaFinancingInfo)) {
              this.zmaFinancingInfo = zmaFinancingInfo
            }
            if (cicFinancingApplyDraftSnapshot && this.$utils.isObjFn(cicFinancingApplyDraftSnapshot)) {
              this.cicFinancingApplyDraftSnapshot = cicFinancingApplyDraftSnapshot
            }
            if (zmaFinancingManagement && this.$utils.isObjFn(zmaFinancingManagement)) {
              this.zmaFinancingManagement = zmaFinancingManagement
            }
            if (cicDepositInfoSnapshotList && Array.isArray(cicDepositInfoSnapshotList)) {
              this.cicDepositInfoSnapshotList = cicDepositInfoSnapshotList
            }
            if (addFileInfoList && Array.isArray(addFileInfoList)) {
              this.addFileInfoList = addFileInfoList
            }
            this.applicationStatus = zmaFinancingManagement.applicationStatus
            this.setInitData(response.data)
          } else {
            this.linkToList(response.errorCode)
          }
        })
      return promise
    },

    setInitData(data) {
      this.$nextTick(() => {
        this.$refs.zmaFinancingInfo.initData(data.zmaUpdateTimeLogs)
        const fundLockData = {
          logs: data.zmaLockMoneyLogs ? data.zmaLockMoneyLogs : [],
          availableBalance: this.zmaFinancingManagement.availableBalance // 可用余额
        }
        this.$refs.fundLock.initData(fundLockData)
      })
    },

    // 拒绝申请弹框关闭
    hide() {
      this.isShow = false
      this.isShowPass = false
    },
    /**
       *打回接口
       * @returns {Promise.<T>|Promise<never | T>}
       */
    zmaRepulse: function(path, zmaPatameter) {
      const params = {}
      var promise = this.axios.post(path, Object.assign(params, zmaPatameter))
        .then(response => {
          if (response.status) {
            this.$router.push('/financingExamineList')
          } else {
            this.linkToList(response.errorCode)
          }
        })
      return promise
    },
    /**
       *通过接口
       * @returns {Promise.<T>|Promise<never | T>}
       */
    zmaAdopt: function(path, zmaPatameter) {
      const params = {}
      var promise = this.axios.post(path, Object.assign(params, zmaPatameter))
        .then(response => {
          if (response.status) {
            this.$router.push('/financingExamineList')
          } else {
            this.linkToList(response.errorCode)
          }
        })
      return promise
    },
    /**
       *拒绝接口
       * @returns {Promise.<T>|Promise<never | T>}
       */
    zmaClose: function(path, zmaPatameter) {
      const params = {}
      var promise = this.axios.post(path, Object.assign(params, zmaPatameter))
        .then(response => {
          if (response.status) {
            this.$router.push('/financingExamineList')
          } else {
            this.linkToList(response.errorCode)
          }
        })
      return promise
    },
    // 打回接口调用
    submitRepulse(value) {
      if (value === '') {
        this.contractParameter.in_log = ''
        this.frontMoneyParameter.a_o = ''
        //   请输入原因
        this.$message.error(this.$t('financingFundDetail.verifyPopupPlaceholder'))
      } else {
        this.contractParameter.in_log = value
        this.frontMoneyParameter.a_o = value
        const applicationStatus = this.applicationStatus
        const pathArr = this.pathArr
        if (applicationStatus === 17) {
          // 贸易合同审核-打回
          this.zmaRepulse(pathArr.contractAuditBack, this.contractParameter)
        } else if (applicationStatus === 18) {
          // 贸易合同一审-打回
          this.zmaRepulse(pathArr.contractAuditFirstBack, this.contractParameter)
        } else if (applicationStatus === 19) {
          // 贸易合同二审-打回
          this.zmaRepulse(pathArr.contractAuditSecondBack, this.contractParameter)
        } else if (applicationStatus === 24) {
          // 定金审核-打回
          this.zmaRepulse(pathArr.depositRepulse, this.frontMoneyParameter)
        } else if (applicationStatus === 25) {
          // 定金一审-打回
          this.zmaRepulse(pathArr.depositFirstInstanceRepulse, this.frontMoneyParameter)
        } else if (applicationStatus === 26) {
          // 定金二审-打回
          this.zmaRepulse(pathArr.depositSecondInstanceRepulse, this.frontMoneyParameter)
        }
      }
    },
    // 通过接口调用
    submitAdopt(value) {
      const applicationStatus = this.applicationStatus
      const pathArr = this.pathArr
      this.contractParameter.in_log = value
      this.frontMoneyParameter.a_o = value

      // console.log('pathArr',this.pathArr)
      if (applicationStatus === 17) {
        // 贸易合同审核-提交
        this.zmaAdopt(pathArr.contractAuditAdopt, this.contractParameter)
      } else if (applicationStatus === 18) {
        // 贸易合同一审-通过
        this.zmaAdopt(pathArr.contractAuditFirstAdopt, this.contractParameter)
      } else if (applicationStatus === 19) {
        // 贸易合同二审-通过
        this.zmaAdopt(pathArr.contractAuditSecondAdopt, this.contractParameter)
      } else if (applicationStatus === 24) {
        // 定金审核-提交
        this.zmaAdopt(pathArr.depositSubmit, this.frontMoneyParameter)
      } else if (applicationStatus === 25) {
        // 定金一审-通过
        this.zmaAdopt(pathArr.depositFirstInstanceAdopt, this.frontMoneyParameter)
      } else if (applicationStatus === 26) {
        // 定金二审-通过
        this.zmaAdopt(pathArr.depositSecondInstanceAdopt, this.frontMoneyParameter)
      }
    },

    // 二审拒绝接口调用
    submitClose(value) {
      if (value === '') {
        this.contractParameter.in_log = ''
        this.frontMoneyParameter.a_o = ''
        //   请输入原因
        this.$message.error(this.$t('financingFundDetail.verifyPopupPlaceholder'))
      } else {
        const applicationStatus = this.applicationStatus
        const pathArr = this.pathArr
        this.contractParameter.in_log = value
        this.frontMoneyParameter.a_o = value
        if (applicationStatus === 19) {
          // 贸易合同-拒绝
          this.zmaClose(pathArr.contractAuditSecondRefuse, this.contractParameter)
        }
      }
    },
    linkToList: function(errorCode) {
      if (errorCode == 'loan_audit_5000005' || errorCode == 'loan_audit_50000031') {
        if (this.menuType && this.mean === 6) {
          this.$router.push('/allorders')
        } else {
          this.$router.push('/financingExamineList')
        }
      } else {
        this.$message.error(this.$t(`financingExamineDetail.${errorCode}`))
      }
    }
  }
}
</script>

<style lang="scss" scoped>

::v-deep{
  .el-tabs--top.el-tabs--border-card > .el-tabs__header .el-tabs__item:nth-child(2), .el-tabs--top.el-tabs--card > .el-tabs__header .el-tabs__item:nth-child(2), .el-tabs--top .el-tabs--left > .el-tabs__header .el-tabs__item:nth-child(2), .el-tabs--top .el-tabs--right > .el-tabs__header .el-tabs__item:nth-child(2), .el-tabs--bottom.el-tabs--border-card > .el-tabs__header .el-tabs__item:nth-child(2), .el-tabs--bottom.el-tabs--card > .el-tabs__header .el-tabs__item:nth-child(2), .el-tabs--bottom .el-tabs--left > .el-tabs__header .el-tabs__item:nth-child(2), .el-tabs--bottom .el-tabs--right > .el-tabs__header .el-tabs__item:nth-child(2){
  padding:0 78px;
  }
}

  .card-box{
    padding: 9px 0 19px;
    display: flex;
    justify-content: flex-start;
    .single-card + .single-card{
      margin-left: 15px;
    }
    .card-item{
      width: 330px;
    }
  }
  ::v-deep .el-tabs--border-card > .el-tabs__content{
    padding: 0;
  }
  .diver{
    border-bottom: 1px solid #EAEAEA;
  }
  .whiteFixed{
    position: fixed;
    border-top:1px solid #EAEAEA;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100px;
    line-height: 100px;
    background: #ffffff;
    z-index: 99;
  }
  .jsbTb {
    width: 570px;
    border-collapse: collapse;
    td {
      font-size: 14px;
      border: 1px solid #E9EBF0;
      padding: 0 10px;
      height: 36px;
      &.td1 {
        width: 180px;
        background: #F8FAFD;
      }
      &.td2 {
        width: 350px;
      }
    }
  }

  .jsbH4 {
    margin-bottom: 10px;
    text-align: center;
    background: #D9E2FE;
    border-radius: 2px;
    font-size: 14px;
    color: #7996F5;
    height: 34px;
    line-height: 34px;
    overflow: hidden;
    vertical-align: middle;
    i {
      display: inline-block;
      background: url(../../assets/images/common/icoHzD.png) no-repeat center;
      width: 14px;
      height: 14px;
      margin-right: 5px;
    }
  }

  .mrfhTb {
    width: 570px;
    border-collapse: collapse;
    tr.tr1 {
      td {
        background: #F8FAFD;
      }
    }
    td {
      font-size: 14px;
      border: 1px solid #E9EBF0;
      padding: 0 10px;
      height: 36px;
      text-align: center;

      &.td1 {
        width: 122px;
      }

      &.td2 {
        width: 230px;
      }

      &.td3 {
        width: 160px;
      }
    }
  }
  .w520{
    width: 520px;
  }
</style>

